import React, { Component } from 'react';
import Navbar from '../Navbar'
import { Input, Collapse, Alert, Row, Col, Card, Button, CardHeader, CardBody, Badge, Spinner, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import Select from 'react-select';

const { proxy } = require('../../ip_api.config')

class Flim_ManageProductImageGroup extends Component {

    constructor(props) {
        super(props)
        this.state = {
            filesDisplay: [],
            selectedOption: [
                {
                    displayName: 'IBrand 2',
                    name: 'iBrand2',
                    selected: '',
                    option: [],
                },
                {
                    displayName: 'IBrand 3',
                    name: 'iBrand3',
                    selected: '',
                    option: [],
                },
                {
                    displayName: 'Item G3',
                    name: 'itemG3',
                    selected: '',
                    option: [],
                },
            ],
            productData: [],
            uploadContent: [],
            deleteList: [],
            customAlert: {
                open: false,
                messages: '',
                status: ''
            },
            showSaveBtn: false,
        }
    }

    componentDidMount() {
        this.get_G3Filter()
        this.get_IBrand2Filter()
        let departmentRole = localStorage.getItem("DepartmentNo");
        if (departmentRole != 'D11') {
            this.props.history.push({
                pathname: '/Flim/ProductInfoTable'
            })
        }
    }

    get_productData = (searchData) => {
        let url = proxy.server + '/flim/getProductData'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(searchData)
        })
            .then(response => response.json())
            .then((responseJson) => {
                switch (responseJson.status) {
                    case 200:
                        console.log("responseJson [get_productData]", responseJson)
                        let res = responseJson.result;
                        for (let key in res) {
                            res[key].edit = <Button color="warning" >จัดการ</Button>
                            res[key].link = <Button color="primary" >รายละเอียด</Button>
                        }
                        this.setState({ productData: res })
                        break;
                    default: this.setState({ productData: [] })
                }
            })
    }

    get_uploadByGroup = (data, whereGroup) => {
        let url = proxy.server + '/flim/getUploadByGroup'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_uploadByGroup]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let files = {};
                        let collapseUploadList = [];
                        responseJson.result.forEach(item => {
                            collapseUploadList.push(false)
                            files[`${item.fieldName}`] = []

                            item.dataCount = 0;

                            switch (item.inputType) {
                                case 'text':
                                    files[`${item.fieldName}`].push({ fileId: '', value: '', type: 'LINK', typeNo: item.typeNo, oldValue: '', remark: '', oldRemark: '' });
                                    break;
                                case 'textarea':
                                    files[`${item.fieldName}`].push({ fileId: '', value: '', type: 'TEXT', typeNo: item.typeNo, oldValue: '' });
                                    break;
                            }
                        });
                        this.setState({ uploadContent: responseJson.result, files: files, collapseUploadList: collapseUploadList })

                        this.get_dataUploadedByItem(whereGroup)
                        break;
                    default: this.setState({ uploadContent: [] })
                }
            })
    }

    get_G3Filter = () => {
        let url = proxy.server + '/flim/getG3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: 'GET_ALL' })
        })
            .then(response => response.json())
            .then((responseJson) => {
                let selectedOption = this.state.selectedOption
                let arr = []
                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '--------------กรุณาเลือก-------------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG3Id, label: val.itemG3Name })
                        })
                        selectedOption[2].option = arr;
                        this.setState({ selectedOption: selectedOption })
                        break;
                    default: selectedOption[2].option = arr; this.setState({ selectedOption: selectedOption })
                }
            })
    }

    get_IBrand2Filter = () => {
        let url = proxy.server + '/flim/getIbrand2Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: 'GET_ALL' })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let selectedOption = this.state.selectedOption

                switch (responseJson.status) {
                    case 200:
                        let arr = []
                        arr.push({ value: '', label: '--------------กรุณาเลือก-------------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand2Id, label: val.iBrand2Name })
                        })
                        selectedOption[0].option = arr;
                        this.setState({ selectedOption: selectedOption })
                        break;
                    default: selectedOption[0].option = arr; this.setState({ selectedOption: selectedOption })
                }
            })
    }

    get_IBrand3Filter = (selected) => {
        let url = proxy.server + '/flim/getIbrand3Filter'
        fetch(url, {
            method: "POST",
            headers: {
                // Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ id: selected })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let selectedOption = this.state.selectedOption
                let arr = []
                switch (responseJson.status) {
                    case 200:
                        arr.push({ value: '', label: '--------------กรุณาเลือก-------------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.iBrand3Id, label: val.iBrand3Name })
                        })
                        selectedOption[1].option = arr;
                        this.setState({ selectedOption: selectedOption })
                        break;
                    default: selectedOption[1].option = arr; this.setState({ selectedOption: selectedOption })
                }
            })
    }

    get_G1Filter = () => {
        let url = proxy.server + '/flim/getG1Filter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                let selectedOption = this.state.selectedOption
                switch (responseJson.status) {
                    case 200:
                        let arr = []
                        arr.push({ value: '', label: '--------------กรุณาเลือก-------------' })
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemG1Id, label: val.itemG1Name })
                        })
                        selectedOption[1].option = arr;
                        this.setState({ selectedOption: selectedOption })
                        break;
                    default: selectedOption[1].option = arr; this.setState({ selectedOption: selectedOption })
                }
            })
    }

    get_dataUploadedByItem = (data) => {
        let url = proxy.server + '/flim/getDataUploadedByGroup'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_dataUploadedByItem]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        const { files } = this.state;
                        let filesCopy = files;
                        responseJson.result.forEach(item => {
                            for (let key in filesCopy) {
                                if (key === item.fieldName) {
                                    switch (item.inputType) {
                                        case 'file':
                                            item.fileName = item.value.substring((item.value.lastIndexOf('/') + 1));
                                            filesCopy[`${item.fieldName}`].push(item)
                                            break;
                                        case 'text':
                                            if (filesCopy[`${item.fieldName}`][0] && filesCopy[`${item.fieldName}`][0].value === '') {
                                                filesCopy[`${item.fieldName}`] = [
                                                    { fileId: item.fileId, value: item.value, type: 'LINK', typeNo: item.typeNo, oldValue: item.value, remark: item.remark, oldRemark: item.remark }
                                                ]
                                            } else {
                                                filesCopy[`${item.fieldName}`].push(
                                                    { fileId: item.fileId, value: item.value, type: 'LINK', typeNo: item.typeNo, oldValue: item.value, remark: item.remark, oldRemark: item.remark }
                                                )
                                            }
                                            break;
                                        case 'textarea':
                                            if (filesCopy[`${item.fieldName}`][0] && filesCopy[`${item.fieldName}`][0].value === '') {
                                                filesCopy[`${item.fieldName}`] = [
                                                    { fileId: item.fileId, value: item.value, type: 'TEXT', typeNo: item.typeNo, oldValue: item.value }
                                                ]
                                            }
                                            break;
                                    }

                                    let uploadContent = this.state.uploadContent.slice();
                                    for (let i = 0; i < uploadContent.length; i++) {

                                        if (item.typeNo === uploadContent[i].typeNo) {
                                            uploadContent[i].dataCount++;
                                        }
                                    }
                                }
                            }
                        });
                        this.setState({ files: filesCopy })
                        break;
                    default:
                        //204, 500 and more...
                        let files2 = this.state.files
                        this.state.uploadContent.forEach(item => {
                            files2[`${item.fieldName}`] = []

                            item.dataCount = 0;

                            switch (item.inputType) {
                                case 'text':
                                    files2[`${item.fieldName}`].push({ fileId: '', value: '', type: 'LINK', typeNo: item.typeNo, oldValue: '', remark: '', oldRemark: '' });
                                    break;
                                case 'textarea':
                                    files2[`${item.fieldName}`].push({ fileId: '', value: '', type: 'TEXT', typeNo: item.typeNo, oldValue: '' });
                                    break;
                            }
                        });

                        this.setState({ files: files2 })
                }
            })
    }

    deleteFileByItem = (whereGroup, isNotAddData) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/deleteUploadedDataByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.deleteList,
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                switch (responseJson.status) {
                    case 200:
                        this.setState({ deleteList: [] })
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')
                        //todo call service for reloading while still on page
                        /* check if user not upload anything just delete file only then call service to reload, 
                        if not then not reload 'cause saving service will reload after successfully saved*/
                        isNotAddData && this.get_uploadByGroup({ userId: localStorage.getItem("ID_User") }, whereGroup)

                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    saveDataByItem = (data, whereGroup) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/postProductManagement'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({ data: data, whereGroup: whereGroup })
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                        //todo call service for reloading while still on page
                        this.get_uploadByGroup({ userId: localStorage.getItem("ID_User") }, whereGroup)
                        this.setState({ deleteList: [] })
                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    saveFilesByItem = (data, whereGroup) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/uploadProductManagement'
        fetch(url, {
            method: "POST",
            body: data
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                        //todo call service for reloading while still on page
                        this.get_uploadByGroup({ userId: localStorage.getItem("ID_User") }, whereGroup)
                        this.setState({ deleteList: [] })
                        break;
                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }

    //todo merge save function
    saveFileAndDataByItem = (files, data, whereGroup) => {
        this.setCustomAlert('กำลังประมวลผล', 'processing')

        let url = proxy.server + '/flim/uploadProductManagement'
        fetch(url, {
            method: "POST",
            body: files
        })
            .then(response => response.json())
            .then(responseJson => {
                switch (responseJson.status) {
                    case 200:
                        let url2 = proxy.server + '/flim/postProductManagement'
                        fetch(url2, {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json;charset=utf-8"
                            },
                            body: JSON.stringify({ data: data, whereGroup: whereGroup })
                        })
                            .then(response => response.json())
                            .then(responseJson => {
                                switch (responseJson.status) {
                                    case 200:

                                        this.setCustomAlert('บันทึกสำเร็จ', 'success')

                                        //todo call service for reloading while still on page
                                        this.get_uploadByGroup({ userId: localStorage.getItem("ID_User") }, whereGroup)
                                        this.setState({ deleteList: [] })

                                        break;
                                    default: this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                                }
                            })
                        break;
                    default: //todo error
                        this.setCustomAlert('ไม่สามารถทำรายการได้ กรุณาติดต่อเจ้าหน้าที่', 'error')
                }
            })
    }


    setCustomAlert = (messages, status) => {
        this.setState({ customAlert: { open: true, messages: messages, status: status } })

        if (status !== 'processing') {
            let load
            window.clearTimeout(load);
            load = window.setTimeout(() => {
                this.setState({ customAlert: { open: false, messages: '', status: '' } })
            }, 2000)
        }
    }

    renderType = (type, name, typeNo) => {
        switch (type) {
            case 'text':
                return (
                    <React.Fragment>
                        <div className="col-md-10" style={{ padding: '0', marginBottom: '5px' }}>
                            <Button color="primary" onClick={() => this.addRowTextInput(name, typeNo)} ><i class="fa fa-plus" aria-hidden="true"></i></Button>
                        </div>
                        {
                            this.state.files[name].length > 0 &&
                            this.state.files[name].map((val, i) => {
                                console.log('val', val)
                                return (
                                    <div style={{ display: 'flex', marginBottom: '10px' }}>
                                        <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>Link</InputGroupText>
                                                </InputGroupAddon>
                                                <Input type="text" name={name} defaultValue={val.value} value={val.value} onChange={(e) => this.handleChangeTextInput(e.target.value, i, name)} />
                                            </InputGroup>
                                        </div> &nbsp;
                                        <div className="col-md-5 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                            <InputGroup>
                                                <InputGroupAddon addonType="prepend">
                                                    <InputGroupText>หมายเหตุ</InputGroupText>
                                                </InputGroupAddon>
                                                <Input type="text" placeholder="หมายเหตุ" name={name} defaultValue={val.remark} value={val.remark} onChange={(e) => this.handleChangeTextInput(e.target.value, i, name, true)} />
                                            </InputGroup>
                                        </div>
                                        <div className="col-md-1 col-sm-4" style={{ textAlign: 'end' }}>
                                            <Button color="danger" onClick={() => this.deleteRowTextInput(i, name, val.fileId)} ><i class="fa fa-trash-o" aria-hidden="true"></i></Button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
            case 'file':
                return (
                    <React.Fragment>
                        <input type="file" style={{ width: '104px' }} onChange={(e) => this.onUpload(name, e.target.files, e)} multiple id="file-upload" />
                        {
                            this.state.files[name] && this.state.files[name].map((val, i) => {
                                return (
                                    <div style={{ display: 'flex', margin: '5px' }} key={i}>
                                        <div style={{ flex: '1' }}>
                                            {
                                                val.type && val.type.split('/')[0] === 'image' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={window.URL.createObjectURL(val)} onClick={() => this.handleDisplayImg(window.URL.createObjectURL(val))} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.name}</span>
                                                    </div>
                                                    : <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span >{val.name}</span>
                                                    </div>
                                            }
                                            {
                                                val.typeName && val.typeName === 'IMAGE' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={`${proxy.server}/${val.value}`} onClick={() => this.handleDisplayImg(`${proxy.server}/${val.value}`)} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.fileName}</span>
                                                    </div>
                                                    : val.typeName === 'FILE' && <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span >{val.fileName}</span>
                                                    </div>
                                            }
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Button color="danger" onClick={() => this.onRemoveFile(name, i, val.fileId)} >
                                                <i class="fa fa-trash-o" aria-hidden="true"></i>
                                            </Button>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
            case 'textarea':
                return (
                    <React.Fragment>
                        {
                            this.state.files[name].length > 0 &&
                            this.state.files[name].map((val, i) => {
                                return (
                                    <Input type="textarea" name={name} value={val.value} id="exampleText" onChange={(e) => this.handleChangeTextInput(e.target.value, 0, name)} />
                                )
                            })
                        }
                    </React.Fragment>
                )
        }
    }

    addRowTextInput = (name, typeNo) => {
        let filesCopy = this.state.files[name]
        filesCopy.push({ fileId: '', value: '', type: 'LINK', typeNo: typeNo, remark: '' })
        this.setState({ files: { ...this.state.files, [name]: filesCopy } })
    }

    deleteRowTextInput = (index, name, fileId) => {
        const { deleteList, files } = this.state;
        let filesCopy = files[name]
        filesCopy.splice(index, 1)
        fileId !== undefined && deleteList.push(fileId)
        this.setState({ files: { ...files, [name]: filesCopy }, deleteList: deleteList })
    }

    handleChangeTextInput = (value, index, name, isLinkRemark) => {
        let filesCopy = this.state.files[name]
        if (isLinkRemark !== undefined) {
            filesCopy[index].remark = value;
        } else {
            console.log('handleChangeTextInput',)
            filesCopy[index].value = value;
        }
        this.setState({ files: { ...this.state.files, [name]: filesCopy } })
    }

    onUpload = (fieldName, files, e) => {
        //there're old data inside for checking duplicated file. 
        let arr = this.state.files[fieldName];
        let checkedDuplicate = false;

        // if upload more than 0 file
        if (files.length > 0) {
            //let's check with old data
            arr.map((val, i) => {
                for (let i = 0; i < files.length; i++) {
                    // existing fileName, it will represent that it comes from DB
                    if ((val.fileName && val.fileName) === files[i].name) {
                        checkedDuplicate = true;
                        // if there's no fileName, it means it just add and not save on DB before
                    } else if ((!val.fileName && val.name) === files[i].name) {
                        checkedDuplicate = true;
                    }
                }
            })
        }

        if (checkedDuplicate) {
            alert('ขออภัยไม่สามารถอัปโหลดไฟล์ซ้ำได้')
        } else {
            for (let i = 0; i < files.length; i++) {
                arr.push(files[i])
            }
            this.setState({ ...this.state.files, [fieldName]: arr })
        }
        // clear value to reset, user can choose the same file if they delete it without saving
        e.target.value = ''
    }

    onRemoveFile = (name, index, fileId) => {
        const { files, deleteList } = this.state;
        let arr = files[name];
        // delete on UI
        arr.splice(index, 1)
        // set for delete on DB
        fileId !== undefined && deleteList.push(fileId)
        this.setState({ ...files, [name]: arr, deleteList: deleteList })
    }

    onSubmit = () => {
        // call delete function
        let mockText = [];
        let mockFile = [];
        const { files } = this.state

        let whereGroup = {
            itemId: '',
            itemDesc: ''
        }

        this.state.selectedOption.map((val, i) => {
            whereGroup[`${val.name}`] = val.selected;
        })

        let data = new FormData()
        let filesCopy = files;

        let isEmptyTextField = false

        for (let key in filesCopy) {
            let value = filesCopy[key];
            value.map((item, i) => {
                switch (item.type) {
                    case 'LINK':
                    case 'TEXT':
                        if (item.value !== '' && item.remark !== '') {
                            if (item.fileId === '') {
                                mockText.push(item)
                            } else if (item.value !== item.oldValue || item.remark !== item.oldRemark) {
                                mockText.push(item)
                            }
                        } else {
                            if (item.fileId !== '') {
                                isEmptyTextField = true
                            }
                        }
                        break;
                    default:
                        if (!item.fileId) {
                            data.append(`${key}`, item)
                            mockFile.push("")
                        }
                }
            });
        }
        data.append("uploadContent", JSON.stringify(this.state.uploadContent))
        data.append("whereGroup", JSON.stringify(whereGroup))

        if (!isEmptyTextField) {
            this.state.deleteList.length > 0 && this.deleteFileByItem(whereGroup, (mockFile.length === 0 && mockText.length === 0))

            if (mockFile.length > 0 && mockText.length > 0) {
                // save all type
                this.saveFileAndDataByItem(data, mockText, whereGroup)
            } else if (mockFile.length === 0 && mockText.length > 0) {
                this.saveDataByItem(mockText, whereGroup)
            } else if (mockFile.length > 0 && mockText.length === 0) {
                this.saveFilesByItem(data, whereGroup)
            }
        } else {
            alert('ไม่สามารถบันทึกค่าใหม่ที่เป็นค่าว่างได้ กรุณากรอกข้อมูลให้ครบถ้วน')
        }
    }

    collapseUploadList = (index) => {
        let collapseUploadList = this.state.collapseUploadList;
        collapseUploadList[index] = !collapseUploadList[index];
        this.setState({ collapseUploadList: collapseUploadList })
    }

    handleChangeSelect = (e, fieldName) => {
        let selectedOption = this.state.selectedOption

        switch (fieldName) {
            case 'iBrand2':
                selectedOption[1].selected = ''
                selectedOption[1].option = [];
                this.get_IBrand3Filter(e.value)
                break;
        }
        selectedOption.map((val, i) => {
            if (val.name === fieldName) {
                val.selected = e.value
            }
        })
        this.setState({ selectedOption: selectedOption })
    }

    handleSearchSubmit = () => {
        let countSelected = 0

        let whereGroup = {
            itemId: '',
            itemDesc: ''
        }

        this.state.selectedOption.map((val, i) => {
            whereGroup[`${val.name}`] = val.selected;
            if (val.selected !== '') {
                countSelected++;
            }
        })

        if (countSelected > 0) {
            this.setState({ showSaveBtn: true })
            this.get_uploadByGroup({ userId: localStorage.getItem("ID_User") }, whereGroup)
        } else {
            alert('กรุณาเลือกอย่างน้อย 1 ตัวเลือก')
        }
    }

    resetFilter = () => {
        let selectedOption = this.state.selectedOption
        selectedOption.map((val, i) => val.selected = '')
        this.setState({ selectedOption: selectedOption })
    }

    handleDisplayImg = (src) => {
        let modal = document.getElementById("showImg");
        let modalImg = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src;
    }

    handleCloseDisplayImg = () => {
        let modal = document.getElementById("showImg");
        modal.style.display = "none";
    }

    render() {
        const { selectedOption } = this.state;

        return (
            <React.Fragment>
                <Navbar nav={'Flim'} menu={'Flim_ManageProductImage'} />
                <div style={{ padding: '10px' }}>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                <Row>
                                    {
                                        selectedOption.map((val, i) => {
                                            return (
                                                <Col xs="12" sm="6" md="6" style={{ padding: '5px' }}>
                                                    <Row>
                                                        <Col xs="12" sm="6" md="3">{val.displayName}:</Col>
                                                        <Col xs="12" sm="6" md="9" >
                                                            <Select
                                                                defaultValue={val.selected}
                                                                value={val.option.filter(option => option.value === val.selected)}
                                                                onChange={(e) => this.handleChangeSelect(e, val.name)}
                                                                options={val.option}
                                                                placeholder={'ค้นหา ' + val.displayName}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                                <Row>
                                    <Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
                                        <div style={{ textAlign: 'end' }}>
                                            <Button color="secondary" onClick={() => this.resetFilter()} ><i class="fa fa-repeat" aria-hidden="true"></i> Reset</Button> &nbsp;
                                            <Button color="primary" onClick={() => this.handleSearchSubmit()} ><i class="fa fa-search" aria-hidden="true"></i> Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-cloud-upload fa-lg" aria-hidden="true"></i> รายการอัปโหลดไฟล์</CardHeader>
                        <CardBody>
                            <React.Fragment>
                                <div style={{ padding: '10px' }}>
                                    <Row>
                                        {this.state.uploadContent.map((val, i) => {
                                            return (
                                                <Card style={{ margin: '10px', width: '100%' }}>
                                                    <CardHeader style={{ backgroundColor: 'rgba(0,0,0,0)', cursor: 'pointer' }} onClick={() => this.collapseUploadList(i)}>
                                                        <div style={{ display: 'flex' }} >
                                                            <span style={{ flex: '1' }}  >{val.label} <Badge color="warning">{val.dataCount > 0 && val.dataCount}</Badge></span>
                                                            <span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.collapseUploadList[i]}>
                                                        <CardBody><Col sm="12" md="12" style={{ padding: '5px' }} key={i}>
                                                            <Row>
                                                                <Col sm="12" md="12">
                                                                    {this.renderType(val.inputType, val.fieldName, val.typeNo)}
                                                                </Col>
                                                            </Row>
                                                        </Col></CardBody>
                                                    </Collapse>
                                                </Card>
                                            )
                                        })}
                                    </Row>
                                    {
                                        this.state.showSaveBtn ? <Row>
                                            <Col sm="12" md="12" style={{ padding: '20px 5px 5px 5px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <div style={{ marginRight: '10px' }}  ><Button color="success" onClick={() => this.onSubmit()} ><i class="fa fa-floppy-o" aria-hidden="true"></i> SAVE</Button></div>
                                                </div>
                                            </Col>
                                        </Row>
                                            : ''
                                    }

                                </div>
                            </React.Fragment>
                            <CustomAlert open={this.state.customAlert.open} messages={this.state.customAlert.messages} status={this.state.customAlert.status} />
                        </CardBody>
                    </Card>
                </div>
                <div id="showImg" class="modal">
                    <span class="close" onClick={() => this.handleCloseDisplayImg()} >&times;</span>
                    <img class="modal-content" id="imgContent" />
                </div>
            </React.Fragment>
        );
    }
}

export default Flim_ManageProductImageGroup;

function CustomAlert(props) {
    /* status => processing, success, warning, error */
    return (
        props.open && <Alert color={props.status === 'processing' ? 'secondary' : props.status}>
            {props.status === 'processing' && <Spinner size="sm" color="secondary" />} {props.messages}
        </Alert>
    )
}